export const environment = {
  production: false,
  apiUrl: 'https://proxy7dev.ger7.com.br',
  // apiUrl: 'https://localhost:44315',
  keycloak: {
    url: 'https://keycloak-hml.ger7.com.br:8443',
    // url: 'http://localhost:8080',
    realm: 'TefBox',
    clientId: 'tefbox-lojista',
  },
};
